export default __webpack_public_path__ + "static/media/attractions7.f661e764.avif";